interface ProseProps {
  children: React.ReactNode
  className?: string
  size?: 'base' | 'lg'
}

export function Prose({ children, className = '', size = 'lg' }: ProseProps) {
  const sizeClass = size === 'lg' ? 'prose-lg' : ''

  return (
    <div className={`prose ${sizeClass} prose-slate prose-headings:text-slate-900 prose-headings:font-semibold prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-6 prose-p:mb-6 prose-ul:my-6 prose-li:my-2 max-w-none ${className}`}>
      {children}
    </div>
  )
}
